import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import type { Datacolumn } from '../datacolumn/datacolumn.component';
import type { SortDirection } from '../datatable.component';

@Component({
  selector: 'app-table-column-header', standalone: true, imports: [CommonModule],
  templateUrl: './column-header.component.html', styleUrls: ['./column-header.component.scss']
})
export class ColumnHeaderComponent {
  private readonly titleCase = new TitleCasePipe();
  @Input() column: Pick<Datacolumn, 'name' | 'title' | 'reg'>;
  @Input() titleTemplate?: TemplateRef<unknown>;
  @Input() index = 0;
  @Input() sortable = false;
  @Input() interactive = false;
  @Input() direction: SortDirection = '';
  @Output() activated = new EventEmitter<Event>();
  @ViewChild('sortControl') sortControl?: ElementRef<HTMLElement>;

  get label(): string { return this.column.title || this.titleCase.transform((this.column.name || '').split(this.column.reg).join(' ')); }
  get action(): string { return this.direction === 'asc' ? 'Sort descending' : this.direction === 'desc' ? 'Clear sorting' : 'Sort ascending'; }
  get accessibleLabel(): string { return `Sort by ${this.label}${this.direction ? ', ' + (this.direction === 'asc' ? 'ascending' : 'descending') : ''}`; }
  get ownsFocus(): boolean { return !!this.sortControl?.nativeElement.contains(document.activeElement); }

  activate(event: Event): void {
    if (!this.sortable) return;
    event.stopPropagation(); this.focus(); this.activated.emit(event);
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.target !== event.currentTarget || event.repeat || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault(); this.activate(event);
  }

  focus(): void { this.sortControl?.nativeElement.focus(); }

  @HostListener('click', ['$event']) stopInteractivePropagation(event: Event): void { if (this.sortable && this.interactive) event.stopPropagation(); }
}
